export const prodSnoozeUptimeShortIds: string[] = [];

export interface SnoozeInstanceAlertUntilTime {
    hostedInstanceId: string;
    metricType: string[];
    snoozeUntilDate: Date;
    comment: string;
    linkToCard?: string;
} 

export const instancesNearingPlatformLimitsToSnooze: SnoozeInstanceAlertUntilTime[] = [
    {
        hostedInstanceId: "HostedInstances-41103",
        metricType: ["CPU"], 
        snoozeUntilDate: new Date("2026-11-02"), 
        comment: "philips-ei (i041103) limits are reviewed monthly as part of its maintenance card (see link)",
        linkToCard: "https://linear.app/octopus/issue/CLOUDPT-11991/assess-philips-ei-platform-cpu-limit-warning"
    },
    {
        hostedInstanceId: "HostedInstances-7696",
        metricType: ["CPU"],
        snoozeUntilDate: new Date("2026-07-01"),
        comment: "Snoozing DRB limits until we work out how to increase their platform limit (see CLOUDPT-11285).",
        linkToCard: "https://linear.app/octopus/issue/CLOUDPT-11285"
    }
];
